import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsTruncatedTextblockCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.truncated-textblock{display:block;margin-bottom:1rem}.truncated-textblock .content{max-height:1.3rem;overflow:hidden;text-overflow:ellipsis;text-wrap:nowrap;margin-bottom:0.5rem}.truncated-textblock .content.open{max-height:unset;overflow:unset;text-wrap:unset;text-overflow:unset}.truncated-textblock .slot-content{margin-bottom:0.5rem}.truncated-textblock .open svg{transform:rotate(-180deg)}";

const FdsTruncatedTextblock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.toggleHandler = createEvent(this, "toggleHandler", 7);
    this.open = false;
    this.content = undefined;
    this.btnExpand = undefined;
    this.btnCollapse = undefined;
    this.containerWidth = undefined;
    this.childNodes = undefined;
    this.truncated = undefined;
  }
  /**
   * Event for toggle open state
   */
  toggleComponent() {
    this.open = !this.open;
    this.toggleHandler.emit({ open: this.open });
  }
  componentDidLoad() {
    this.containerWidth = this.el.parentElement.offsetWidth;
    this.childNodes = !!this.el.childNodes.length;
    const treshold = this.el.offsetWidth / 8;
    if (treshold <= this.content.length) {
      this.truncated = true;
    }
  }
  renderButton() {
    if (this.truncated || this.childNodes) {
      return (h("fds-button", { variant: "minor", class: "button m-b-xl", icon: "arrowDown", iconPos: "right", onClick: () => this.toggleComponent() }, h("button", { class: this.open ? 'open' : null }, this.open ? this.btnCollapse : this.btnExpand)));
    }
    else {
      return null;
    }
  }
  render() {
    return (h(Host, null, h("div", { class: "truncated-textblock", style: { 'maxWidth': `${this.containerWidth}px` } }, h("div", { class: this.open ? 'content open' : 'content' }, this.content), h("div", { role: "region", class: this.childNodes ? 'slot-content' : null, "aria-hidden": this.open ? 'false' : 'true', hidden: this.open ? null : true }, h("slot", null)), this.renderButton())));
  }
  get el() { return getElement(this); }
};
FdsTruncatedTextblock.style = fdsTruncatedTextblockCss;

export { FdsTruncatedTextblock as fds_truncated_textblock };
